// import dotenv from 'dotenv';

// dotenv.config();
// const API_BASE_URL = process.env.API_BASE_URL;

// API functions for interacting with draft orders
import { API_BASE_URL } from '../utils/constants';

// export async function fetchDraftOrders(token) {
//   console.log('fetchDraftOrders', token, cursor, limit);
//   const response = await fetch(`${API_BASE_URL}/api/draft-orders?token=${encodeURIComponent(token)}`);
  
//   if (!response.ok) {
//     const error = await response.json();
//     throw new Error(error.error || 'Failed to load quotes', response);
//   }
  
//   return await response.json();
// }

export async function fetchDraftOrders(token, { cursor, limit } = {}) {
  console.log('fetchDraftOrders', token, cursor, limit);
  const params = new URLSearchParams({ token });
  if (cursor) params.set('cursor', cursor);
  if (limit) params.set('limit', String(limit));

  const response = await fetch(`${API_BASE_URL}/api/draft-orders?${params.toString()}`);
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to load quotes');
  }
  // { draftOrders, pageInfo: { hasNextPage, endCursor } }
  return await response.json();
}

export async function fetchDraftOrderById(orderId, token) {
  // console.log('fetchDraftOrderById', orderId, token);
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}?token=${encodeURIComponent(token)}`);
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to load quote');
  }
  
  return await response.json();
}

// export async function approveDraftOrder(orderId, note, token, poFile) {
//   // console.log('approveDraftOrder', orderId, note, token);
//   const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/approve?token=${encodeURIComponent(token)}`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({ note }),
//   });
  
//   if (!response.ok) {
//     const error = await response.json();
//     throw new Error(error.error || 'Failed to approve quote');
//   }
  
//   return await response.json();
// }

export async function approveDraftOrder(orderId, note, token, poFile) {
  const url = `${API_BASE_URL}/api/draft-orders/${orderId}/approve?token=${encodeURIComponent(token)}`;
  let options = { method: 'POST' };

  if (poFile instanceof File) {
    const form = new FormData();
    form.append('note', note || '');
    form.append('poFile', poFile);
    options.body = form;
  } else {
    options.headers = { 'Content-Type': 'application/json' };
    options.body = JSON.stringify({ note });
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    let message = 'Failed to approve quote';
    try {
      const data = await response.json();
      message = data.error || message;
    } catch {
      message = response.statusText || message;
    }
    console.error('[approveDraftOrder]', response.status, message);
    throw new Error(message);
  }
  return await response.json();
}

export async function requestUpdates(orderId, request, token) {
  // console.log('requestUpdates', orderId, request, token);
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/request-updates?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ request }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to request updates');
  }
  
  return await response.json();
}

export async function declineDraftOrder(orderId, reason, token) {
  // console.log('declineDraftOrder', orderId, reason, token);
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/decline?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ reason }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to decline quote');
  }
  
  return await response.json();
}

export async function undoDeclineDraftOrder(orderId, token) {
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/undo-decline?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to undo decline');
  }

  return await response.json();
}

export async function requestExtension(orderId, request, token) {
  // console.log('requestExtension', orderId, request, token);
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/request-extension?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ request }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to request extension');
  }
  
  return await response.json();
}

export async function askQuestion(orderId, question, token) {
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/ask-question?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ question }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to ask question');
  }
  
  return await response.json();
}

export async function updateDraftOrderLineItems(orderId, lineItems, comment, token) {
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/update-line-items?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ lineItems, comment }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to update line items');
  }
  
  return await response.json();
}

export async function uploadCompetitorQuote(orderId, token, file) {
  const url = `${API_BASE_URL}/api/draft-orders/${orderId}/competitor-quote?token=${encodeURIComponent(token)}`;
  const form = new FormData();
  form.append('competitorQuoteFile', file);

  const response = await fetch(url, {
    method: 'POST',
    body: form,
  });
  console.log('uploadCompetitorQuote', response);

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to upload competitor quote');
  }
  return await response.json();
}

/** Request a new portal link when JWT has expired (no auth required). */
export async function requestPortalLink(email, { expiredToken, draftOrderId } = {}) {
  const response = await fetch(`${API_BASE_URL}/api/request-portal-link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      expiredToken: expiredToken || undefined,
      draftOrderId: draftOrderId || undefined,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to submit request');
  }
  return data;
}

export async function sendShareQuoteEmail(orderId, token, toEmails, shareUrl) {
  const response = await fetch(`${API_BASE_URL}/api/draft-orders/${orderId}/share-quote?token=${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ to: toEmails, shareUrl }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to send email');
  }
  return await response.json();
}